import { createFileRoute } from '@tanstack/react-router';
import { ApiKeysPage, apiKeysSearchSchema } from '../../features/B8/api-keys-page';

/** "API ומפתחות" (mockup #/api): keys, recent requests, outgoing webhooks, link to /api/docs. Lane B8-web. */
export const Route = createFileRoute('/_app/api-keys')({
  validateSearch: (s: Record<string, unknown>) => apiKeysSearchSchema.parse(s),
  component: ApiKeysRoute,
});

function ApiKeysRoute() {
  const search = Route.useSearch();
  return <ApiKeysPage search={search} />;
}
